import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import { FormTypes } from '../../../enums';
import lang from '../language.json';
import BreakdownValue from '../styles/BreakdownValue';

type BorrowerShareOfIncomeProps = {
  selectedResult: CalculationResult;
  currentYear: number;
};

const BorrowerShareOfIncome = ({
  selectedResult,
  currentYear,
}: Readonly<BorrowerShareOfIncomeProps>) => {
  const borrowerShare = selectedResult.getInputAsFloat(
    FormTypes.Form1120,
    currentYear,
    'borrowerShareOfIncomeOrLoss',
  );
  const addbacks = selectedResult.getInputAsFloat(
    FormTypes.Form1120,
    currentYear,
    'subTotal',
  );
  const percentageOwnership =
    selectedResult.getInputAsFloat(
      FormTypes.ScheduleG,
      currentYear,
      'percentageOwnership',
    ) * 100;

  const {
    FIELDS: { ['1120']: FIELDS },
  } = lang;

  return (
    <BreakdownValue
      name={FIELDS.BORROWER_SHARE_OF_INCOME}
      value={borrowerShare}
      isCurrency={true}
    >
      <BreakdownValue name={FIELDS.ADDBACK_DEDUCTION} value={addbacks} />
      <BreakdownValue
        name={FIELDS.PERCENTOWNERSHIP}
        value={<>&times;{percentageOwnership}%</>}
        isCurrency={false}
      />
    </BreakdownValue>
  );
};

export default BorrowerShareOfIncome;
